import { useEffect, useState } from "react"
import { getDocumentReferList } from "../../../store/api/Users";
import BihamtaTable from "../../../Components/BihamtaTable";
import { workItemTypesArray } from "../../../store/api/CommonFunctions";

export default function ReferList({ id, type, refresh })
{
    const [referList, setReferList] = useState([]);
    const referCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "تاریخ ارجاع", colName: "PEnterDate" },
        { colTitle: "ارجاع دهنده", colName: "ReferByName" },
        { colTitle: "ارجاع به", colName: "UserName" },
        { colTitle: "شرح ارجاع", colName: "ReferDescription" },
        { colTitle: "خوانده شده", colName: "IsRead", colType:"boolean" },
        { colTitle: "انجام شده", colName: "IsDone", colType:"boolean" },
        { colTitle: "رد شده", colName: "IsRejected" , colType:"boolean"},
        { colTitle: "دلیل رد", colName: "RejectDescription" },
    ]
    useEffect(() => {
        getDocumentReferList(workItemTypesArray[type-1], null, null, null, setReferList, id);
    },[refresh])
    return (
        <BihamtaTable columns={referCols} dataList={referList} />
    )
}